export const MODAL_HEADING_TEXT = "All Filters";
export const CANCELLATION_HEADING_TEXT = "Cancellation";
export const SPECIFICATIONS_HEADING_TEXT = "Specifications";
